// extracted by mini-css-extract-plugin
export default {"subBtn":"madalAddOneAbsence_subBtn__n9pBT"};